import React, { useEffect, useState } from "react";
import I9form from "../legalforms/I9form";
import { useParams } from "react-router";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import Spinner from "../../components/Spinner";

const ContinueCase = () => {
  const params = useParams();
  const [loader, setLoader] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [unconfirmedData, setUnconfirmedData] = useState([]);
  const [i9Data, seti9Data] = useState(null);
  const [photMatchImage, setPhotoMatchImage] = useState("");

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    const element = document.getElementById("main");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  //fetch case details
  const fetchData = async () => {
    setLoader(true);
    const obj = {
      caseId: params?.caseId,
    };
    console.log(obj);
    await ApiHelper.post(API.continueCase, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          seti9Data(resData?.data?.i9Data);
          setCompanyAddress(resData?.data?.company_address);
          setCompanyName(resData?.data?.company_name);
          setUnconfirmedData(resData?.data?.UnconfirmedData);
          setPhotoMatchImage(resData?.data?.RetrivePhoto);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };
  return (
    <div className="sidebar_open" id="main">
      <I9form
        review={true}
        data={i9Data}
        companyName={companyName}
        companyAddress={companyAddress}
        verifyStatus={true}
        fetchSections={fetchData}
        unconfirmedData={unconfirmedData}
        photMatchImage={photMatchImage}
      />
      {loader && <Spinner />}
    </div>
  );
};

export default ContinueCase;
